import { BenefitTypes } from "@/@Interfaces/BenefitsProps";


export const benefit_types: BenefitTypes[] = [
    { value: "Local", label: "Local" },
    { value: "Global", label: "Global" }
  ];